module.exports = __webpack_public_path__ + "img/icon_10.08ebd93f.png";